// src/components/modals/ForgetPasswordModal.js
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import React, { useEffect } from "react";

import { useSession } from "../../context/SessionContext";
import {
  defaultTenant,
  getAllTenantUserData,
  postDefaultTenant,
} from "../../services/academicService";
import { getPublicTenantLogoByFilename } from "../../services/publicService";

const TenantChangeModal = ({ show, onClose }) => {
  const userSession = useSession();
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [allTenantUser, setAllTenantUser] = React.useState([]);

  const handleSelect = async (option) => {
    if (!option) return;
    setSelectedOption(option);
    try {
      await postDefaultTenant(option.value);

      // Save selected tenant
      localStorage.setItem("selectedTenant", JSON.stringify(option));

      // -----------------------------------------------
      // Fetch new tenant's logo and update localStorage
      // so NavHader shows correct logo after reload
      // -----------------------------------------------
      try {
        const res = await defaultTenant();
        const logoObj = res?.defaultTenant?.tenant?.logo;
        const logoFileName =
          logoObj?.fileName ||
          logoObj?.filename ||
          (typeof logoObj === "string" ? logoObj : null);

        if (logoFileName) {
          const logoRes = await getPublicTenantLogoByFilename(logoFileName);
          const fileUrl =
            typeof logoRes === "string"
              ? logoRes
              : logoRes?.fileUrl || logoRes?.url || "";
          if (fileUrl) {
            localStorage.setItem("tenantLogoUrl", fileUrl);
          } else {
            localStorage.removeItem("tenantLogoUrl");
          }
        } else {
          // No logo for this tenant → clear so default image shows
          localStorage.removeItem("tenantLogoUrl");
        }
      } catch (logoErr) {
        console.error("Failed to fetch new tenant logo:", logoErr);
        localStorage.removeItem("tenantLogoUrl");
      }

      window.location.reload();
    } catch (error) {
      console.error("Error sending tenant:", error);
    }
  };

  async function handleAllTenantUser() {
    try {
      const data = await getAllTenantUserData();
      const res = data?.map((tenant) => ({
        value: tenant?.id,
        label: tenant?.name,
      }));

      setAllTenantUser(res);
    } catch (e) {
      console.log(e);
    }
  }

  async function handleGetDefaultTenant() {
    try {
      const response = await defaultTenant();

      const tenant = response?.defaultTenant?.tenant;

      if (tenant) {
        const option = {
          value: tenant.id,
          label: tenant.name,
          id: tenant.id,
        };
        setSelectedOption(option);
        localStorage.setItem("selectedTenant", JSON.stringify(option));
      }
    } catch (error) {
      console.error("Error sending tenant:", error);
    }
  }

  console.log("User Session in Header:", userSession);

  useEffect(() => {
    if (userSession?.role !== "super-admin") {
      handleAllTenantUser();
      handleGetDefaultTenant();
    }
  }, [userSession]);

  return (
    <Modal className="fade" show={show} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Switch Academy</Modal.Title>
        <Button variant="" className="btn-close" onClick={onClose} />
      </Modal.Header>

      <Modal.Body>
        <Select
          value={selectedOption}
          onChange={handleSelect}
          options={allTenantUser}
          placeholder="Select Academy"
          style={{
            lineHeight: "40px",
            color: "#7e7e7e",
            paddingLeft: " 15px",
          }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default TenantChangeModal;
